import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { Button } from './Button';
import { ValueBadges } from './ValueBadges';
import { checkoutUrl, ctaLabel, trackCheckout } from '../data/offer';
const highlights = ['Complete 6-in-1 System', '5 Strategic Bonuses', 'Full Access Today'];
export function Hero() {
  return <section className="relative pt-8 sm:pt-12 pb-14 px-4 overflow-hidden bg-carbon" data-id="element-202" data-mp="4jm69oq8r3r3">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-carbon-card via-carbon to-carbon -z-0" data-id="element-203" data-mp="128pijeo72z53" />
      <div className="relative max-w-5xl mx-auto flex flex-col items-center text-center" data-id="element-204" data-mp="sarv2te5t6dj">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        ease: [0.23, 1, 0.32, 1]
      }} className="w-full" data-id="element-205" data-mp="ncgkggg1iru9">
          <div className="inline-flex items-center gap-2 px-4 py-1 rounded-full border border-gold/50 text-gold font-semibold text-[10px] sm:text-sm tracking-wide whitespace-nowrap mb-4 sm:mb-6" data-id="element-206" data-mp="381xkux4z309n">
            🥋 Brazilian Jiu Jitsu Coach Ready
          </div>
          <p className="text-gold font-bold uppercase tracking-[0.2em] text-[11px] sm:text-sm mb-3" data-id="element-207" data-mp="3o5j2v997rhla">
            6-in-1 Complete BJJ Coaching System
          </p>
          <h1 className="text-2xl sm:text-4xl md:text-5xl lg:text-6xl font-serif font-bold leading-tight mb-6 sm:mb-8 text-white" data-id="element-208" data-mp="3e8ecex8c4zyo">
            Solve an entire year of BJJ classes{' '}
            <span className="text-gold" data-id="element-209" data-mp="358zpg7rdn7ix">in just 5 minutes</span>
          </h1>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.5,
        delay: 0.1,
        ease: [0.23, 1, 0.32, 1]
      }} className="w-full max-w-[320px] sm:max-w-lg md:max-w-2xl mb-6 sm:mb-8" data-id="element-210" data-mp="2qkmt39odnmnw">
          <img src="https://cdn.magicpatterns.com/uploads/vwZpZsJZXgaTdK2NxBPBCr/Diseno_sin_titulo_(72).png" alt="Brazilian Jiu Jitsu Coach Ready — The complete 6-in-1 coaching system box set" className="w-full h-auto drop-shadow-[0_30px_60px_rgba(0,0,0,0.7)]" data-id="element-211" data-mp="2lla68oxiaflb" />
        </motion.div>

        <div className="w-full" data-id="element-212" data-mp="id03goyxw2nl">
          <ValueBadges className="max-w-3xl mx-auto mb-6 sm:mb-8" data-id="element-213" data-mp="ia5kz2zhkrwt" />
          <p className="text-sm sm:text-lg md:text-xl text-mist leading-snug max-w-3xl mx-auto mb-3" data-id="element-214" data-mp="degdmdh866py">
            <span className="font-semibold text-gold" data-id="element-215" data-mp="1azkqxecanulv">BJJ Coach Ready</span> —
            100 complete ready-to-teach Brazilian Jiu Jitsu lessons, 4 volumes
            and 5 strategic bonuses
          </p>
          <p className="text-white font-bold uppercase tracking-wider text-xs sm:text-sm mb-6 sm:mb-8" data-id="element-216" data-mp="111525i0qoxfj">
            100% Visual. Built for real BJJ classes.
          </p>
          <div className="flex justify-center mb-5 sm:mb-7" data-id="element-217" data-mp="3lt73mli5bhrm">
            <Button href={checkoutUrl} target="_blank" onLinkClick={trackCheckout} className="text-sm sm:text-lg md:text-xl py-3 sm:py-5 px-6 sm:px-10 whitespace-nowrap" data-id="element-218" data-mp="3hrd8stumt7zd">
              {ctaLabel}
            </Button>
          </div>
          <div className="flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs sm:text-sm text-smoke" data-id="element-219" data-mp="269zi3saawvnv">
            {highlights.map(highlight => <div key={highlight} className="flex items-center gap-1.5" data-id="element-220" data-mp="2b1hj2gcbqw8u">
                <CheckIcon size={14} className="text-gold" data-id="element-221" data-mp="2g0lsn835uvzp" />
                <span data-id="element-222" data-mp="2g257cu964yzd">{highlight}</span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}